import React from 'react';
import DataPlatform from '@app/model/_common/DataPlatform';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import {
	useMarketStateFilterInputTools,
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';


type DashboardSelectPlatformFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectPlatformFilter = React.memo(
	function DashboardSelectPlatformFilter({ filter, onFilter }: DashboardSelectPlatformFilterProps) {
		const { isDashboardFilterEnabled } = useMarketStateFilterInputTools();
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.PLATFORM);

		const menuItems = [
			{ name: 'Any Device', value: undefined },
			{ name: 'Desktop', value: DataPlatform.WEB },
			{ name: 'Mobile Web', value: DataPlatform.MOBILE },
		];

		const onSelect = (platform: DataPlatform) => {
			onFilter({ ...filter, platform });
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.platform}
														 onSelect={onSelect}
														 menuDescription="Mobile rates may differ from desktop rates; do you wish to include them?"
														 disabled={!providerSupportsFilter} />;

	},
);

export default DashboardSelectPlatformFilter;